// extracted by mini-css-extract-plugin
export default {"titleRow":"c724ad34","buttonGroup":"c1b38b39"};